export default Object.freeze({
    CONSENT: 'cookies.accepted',
})
